import { render } from "./FlowViewContent.vue?vue&type=template&id=fcbe3768&scoped=true"
import script from "./FlowViewContent.vue?vue&type=script&lang=js"
export * from "./FlowViewContent.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-fcbe3768"

export default script